export const getNotificationCountString = (
  notificationCount?: number
): string => {
  if (notificationCount === null || notificationCount === undefined) {
    return '-'
  }
  return notificationCount > 9 ? '9+' : String(notificationCount)
}
